<script lang="ts" setup>
import UserProfileTable from "@/data-views/tables/user_profile/UserProfileTable.vue";
definePage({
  meta: {
    action: "read",
    subject: "UserProfile",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <UserProfileTable />
    </VCol>
  </VRow>
</template>
